import setup from "app/setup/pack";
import Application from "custom/demo/application";

setup({Component: Application});
